import { render, staticRenderFns } from "./MovimientoDispositivos.vue?vue&type=template&id=96cc59ec&"
import script from "./MovimientoDispositivos.vue?vue&type=script&lang=ts&"
export * from "./MovimientoDispositivos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports